module.exports = __webpack_public_path__ + "static/img/货船.fbab1f37.png";